import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { DeviceInfo } from '@ezugi/utils';

export const Container = styled.div`
  padding: 10px 5px 2px;
`;

export const DiceWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 86px;

  > svg {
    filter: drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.7));
    margin: 0px 6px;
    width: 32px;
    height: 32px;

    circle {
      fill: #FEF2DA;
    }
    rect {
      fill: #D2413C;
    }
  }

  > svg:first-child {
    transform-origin: left;
    transform: translateY(20%) rotate(-12deg);
  }

  > svg:last-child {
    transform-origin: right;
    transform: translateY(20%) rotate(12deg);
  }
`;

export const Details = styled.div`
  color: #FFFFFF;
  font-size: 15px;
  text-align: center;
  font-weight: normal;
  margin-top: 8px;
`;

const gameResultsStyle = `
  height: 100%;
  width: 100%;
  position: absolute !important;

  @media all and (orientation: landscape) {
    position: fixed !important;
  }

  top: 0;
  left: 0;
  [data-name='win-animation'] {
    display: none;
    position: absolute;
  }
`;

export const gameResultsClassName = DeviceInfo.isHandheld ? css(gameResultsStyle) : css`
  ${gameResultsStyle}
  [data-name='win-animation'] {
    top: ${SIZES.APPBAR_PORTRAIT_HEIGHT}px;
    left: 50%;
    width: 50%;
    transform: translateX(-50%);
    bottom: 26px !important;
    height: 200px;
  }
`;

const resultMessageStyle = `
  min-width: 180px;
  position: relative;
  top: 5%;
  background: rgba(0, 0, 0, 0.7);
  mix-blend-mode: normal;
  backdrop-filter: blur(8px);
  border-radius: 16px;
  height: auto;
  width: auto;
  justify-content: flex-start;
  margin: 0 auto;
  padding: 5px 20px 10px;

  [data-name="tip-button"] {
    background: linear-gradient(180deg, #FFB052 0%, #E48C23 78.12%, #CF8A39 92.19%, #C77311 100%);
    border-radius: 32px;
    text-transform: uppercase;
    border: 2px solid rgb(255, 179, 0);
    color: #FFFFFF;
    line-height: 14px;
    text-shadow: 0px 1px 1px rgb(0 0 0 / 25%);
    padding: 13px 8px;
    font-size: 12px;
    font-weight: bold;
    margin: 4px 0;
  }

  [data-name="win-message"] {
    top: 0;
    color: #FFFFFF;
    font-size: 15px;
    margin-top: 2px;
    font-weight: normal;

    div {
      color: #E8A702;
      font-size: 56px;
    }
  }
`;

export const resultMessageClassName = DeviceInfo.isHandheld
  ? css`
      ${resultMessageStyle}

      transform: scale(0.7);

      @media all and (orientation: landscape) {
        justify-content: flex-start;
      }

      @media all and (orientation: portrait) {
        top: 21vh;
        justify-content: flex-start;
        height: auto !important;
      }
    `
  : css`
      ${resultMessageStyle}
      transform: scale(1.2);
      top: 0;
  `;
